/**
 * Who may open which page. The API refuses anyway (403 / 404): this only
 * spares a customer, or a user without the permission, an empty page and an
 * error toast. Same rules as the side and invoicing menus.
 *
 * A rule matches a route by name or by path prefix; `gate` is a CASL
 * permission (one of them when an array), `notForCustomer` shuts the page to
 * customer users.
 */
const INVOICING_DOCUMENT_FORMS = [
  'invoice_form_new_route',
  'invoice_form_edit_route',
  'invoicing_quote_new_route',
  'invoicing_purchase_order_new_route',
  'invoicing_credit_note_new_route',
  'work_form_invoice_new_route',
  'work_form_quote_new_route',
  'work_form_purchase_order_new_route',
  'work_form_credit_note_new_route'
]

export const ACCESS_RULES = [
  { path: '/settings', gate: 'see_content', notForCustomer: true },
  { path: '/planning', gate: 'see_planning', notForCustomer: true },
  { path: '/report_planing', gate: 'see_planning', notForCustomer: true },
  { path: '/urn', gate: 'see_planning', notForCustomer: true },
  { path: '/stats', gate: 'see_content', notForCustomer: true },
  { path: '/note', gate: 'see_content', notForCustomer: true },
  { path: '/invoicing/check', gate: 'see_invoicing', notForCustomer: true },
  { path: '/invoicing/export', gate: 'manage_invoicing', notForCustomer: true },
  // Quotes, purchase orders and credit notes: not in a customer's menu.
  { path: '/invoicing/quote', notForCustomer: true },
  { path: '/invoicing/purchase-order', notForCustomer: true },
  { path: '/invoicing/credit-note', notForCustomer: true },
  // Activity logs: an invoice's is refused to a customer by the API; a
  // work's would show the staff's field changes.
  {
    names: ['invoice_activity_route', 'work_form_activities_route'],
    notForCustomer: true
  },
  {
    names: INVOICING_DOCUMENT_FORMS,
    gate: 'manage_invoicing',
    notForCustomer: true
  }
]

function matches(rule, route) {
  if (rule.names) return rule.names.includes(route.name)
  return route.path === rule.path || route.path.startsWith(`${rule.path}/`)
}

/**
 * @param {{ name?: string, path: string }} route
 * @param {{ can: (permission: string) => boolean, isCustomer: boolean }} user
 */
export function canAccess(route, { can, isCustomer }) {
  return ACCESS_RULES.filter((rule) => matches(rule, route)).every((rule) => {
    if (rule.notForCustomer && isCustomer) return false
    if (!rule.gate) return true
    const gates = Array.isArray(rule.gate) ? rule.gate : [rule.gate]
    return gates.some((gate) => can(gate))
  })
}
